import format from 'date-fns/format';
import parse from 'date-fns/parse';

function formatAsYear(dateAsIsoString) {
  return parse(dateAsIsoString).getFullYear();
}

function checkType(arg) {
  return typeof arg;
}

function isText(text) {
  return checkType(text) === 'string';
}

export function formatProjectDate(dateStart, dateCompleted) {
  if (!dateStart && !dateCompleted) {
    return '';
  }

  const startYear = dateStart && formatAsYear(dateStart);
  const endYear = dateCompleted && formatAsYear(dateCompleted);

  if (startYear === endYear) {
    return startYear;
  }
  return [startYear, endYear].filter(x => !!x).join(' - ');
}

export function formatDateWithYear(dateTimeStamp) {
  if (!dateTimeStamp || isNaN(parse(dateTimeStamp))) {
    return '';
  }

  return format(parse(dateTimeStamp), 'D MMM YYYY');
}

export function formatDateWithoutYear(dateTimeStamp) {
  if (!dateTimeStamp || isNaN(parse(dateTimeStamp))) {
    return '';
  }

  return format(parse(dateTimeStamp), 'D MMM');
}

export function formatTextUpperCase(text) {
  return isText(text) ? text.toUpperCase() : '';
}

export function formatCapitalFirstLetter(text) {
  return isText(text) ? text.charAt(0).toUpperCase() + text.slice(1) : '';
}

export function formatCapitalize(text) {
  return text.toLowerCase().replace(/\b\w/g, l => l.toUpperCase());
}

export const formatNumberToDollarAmount = float =>
  Number(float).toLocaleString();

export const formatBackOfficeDate = isoDateStr => {
  if (isoDateStr === null) {
    return 'None';
  } else {
    return format(parse(isoDateStr), 'D MMM YYYY, [a][t] h:mm:ssa');
  }
};

export const pluralise = (word, number) => (number === 1 ? word : `${word}s`);

export const formatIdealStart = (startAsap, dateStart) => {
  // New selections on the create project form:
  // 1 - 2 weeks -> sets startAsap true
  // flexible -> sets startAsap false + dateSart null
  // select date -> startAsap false + dateStart as date selected
  if (startAsap) {
    return '1 to 2 weeks';
  }
  if (!startAsap && !dateStart) {
    return 'Flexible';
  }
  if (!startAsap && dateStart) {
    return formatDateWithYear(dateStart);
  }
};

// organisationIndustry is the organisation's industry
// projectBriefIndustries is the client selected industries from the project brief.
// this handles data coming back from ES as an array of strings: ['x', 'y']
// and handles data coming from GQL coming as array of objects [{name: 'x'}, {name: 'y'}]
export const formatIndustry = (
  organisationIndustry,
  projectBriefIndustries
) => {
  const isEveryIndustryAnObject = industry => typeof industry === 'object';

  let result = null;
  if (projectBriefIndustries && projectBriefIndustries.length > 0) {
    result = (projectBriefIndustries.every(isEveryIndustryAnObject)
      ? projectBriefIndustries.map(industry => industry.name)
      : projectBriefIndustries
    ).join(', ');
  } else if (organisationIndustry) {
    result = organisationIndustry;
  }
  return result;
};

export const genValidUrl = url => {
  const protocolRegex = /^(http(s?)):\/\//gi;
  return url && url.match(protocolRegex) ? url : `http://${url}`;
};
